import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ChatUsersValidationError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ChatUsersValidationError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ChatUsersValidationError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatUsersValidationError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
